module.exports = new __parcel__URL__("open-external.c4f71fa9.svg").toString();